import { projectsProjectDetailHostCapability, projectsProjectDetailHostSlots, } from '@crest/module-projects/contracts/detail-host';
import { defineProjectsProjectDetailLauncher } from '@crest/module-projects/contracts/detail-launcher';
import { platformMyDayHostCapability, platformMyDayHostSlots, } from '@crest/platform-contracts/hosts';
import { tasksSettingRegistrations } from '../settings/tasks-setting-definitions.js';
import { tasksModuleManifest } from '../tasks.module.js';
export const tasksWebModuleContribution = {
    moduleId: 'tasks',
    manifest: tasksModuleManifest,
    settingRegistrations: tasksSettingRegistrations,
    settingEditors: [{
            id: 'tasks.web.settings.focus-configuration',
            moduleId: 'tasks',
            settingKey: 'tasks.focus.configuration',
            priority: 10,
            load: () => import('./tasks-focus-configuration-setting-editor.js'),
        }, {
            id: 'tasks.web.settings.notification-configuration',
            moduleId: 'tasks',
            settingKey: 'tasks.notifications.configuration',
            priority: 20,
            load: () => import('./tasks-notification-configuration-setting-editor.js'),
        }],
    hostContracts: [],
    hostContributions: [
        {
            id: 'tasks.web.platform.my-day',
            moduleId: 'tasks',
            slot: platformMyDayHostSlots.primary,
            contractVersion: platformMyDayHostCapability,
            requiredPermission: 'tasks.tasks.read-own',
            settingCondition: {
                key: 'tasks.focus.configuration',
                property: 'enabled',
                equals: true,
            },
            priority: 20,
            errorBehavior: 'inline',
            emptyBehavior: 'collapse',
            load: () => import('./tasks-my-day.panel.js'),
        },
        {
            id: 'tasks.web.projects.task-summary',
            moduleId: 'tasks',
            slot: projectsProjectDetailHostSlots.sidebar,
            contractVersion: projectsProjectDetailHostCapability,
            requiredPermission: 'tasks.tasks.read-own',
            settingCondition: {
                key: 'tasks.focus.configuration',
                property: 'projectPanelEnabled',
                equals: true,
            },
            priority: 50,
            errorBehavior: 'inline',
            emptyBehavior: 'inline',
            launcher: defineProjectsProjectDetailLauncher({
                fallbackLabel: 'Tasks',
                fallbackDescription: 'Open the work assigned to this Project.',
                defaultSize: 'standard',
                supportedSizes: ['compact', 'standard', 'wide'],
            }),
            load: () => import('./tasks-project-task-summary.panel.js'),
        },
    ],
    routes: [
        {
            id: 'tasks.web.work-queue',
            moduleId: 'tasks',
            path: '/tasks',
            requiredPermission: 'tasks.tasks.read-own',
            navigation: {
                id: 'tasks.navigation.work-queue',
                fallbackLabel: 'Tasks',
                labelConfigurationKey: 'tasks.copy.work-queue',
                labelValueProperty: 'navigationLabel',
                priority: 60,
            },
            load: () => import('./tasks-work-queue.page.js'),
        },
        {
            id: 'tasks.web.focus',
            moduleId: 'tasks',
            path: '/tasks/focus',
            requiredPermission: 'tasks.focus.read',
            settingCondition: {
                key: 'tasks.focus.configuration',
                property: 'enabled',
                equals: true,
            },
            navigation: {
                id: 'tasks.navigation.focus',
                fallbackLabel: 'Focus',
                labelConfigurationKey: 'tasks.copy.focus',
                labelValueProperty: 'navigationLabel',
                priority: 61,
            },
            load: () => import('./tasks-focus.page.js'),
        },
        {
            id: 'tasks.web.notifications',
            moduleId: 'tasks',
            path: '/tasks/notifications',
            requiredPermission: 'tasks.tasks.read-own',
            navigation: {
                id: 'tasks.navigation.notifications',
                fallbackLabel: 'Task notifications',
                labelConfigurationKey: 'tasks.copy.notifications',
                labelValueProperty: 'navigationLabel',
                priority: 62,
            },
            load: () => import('./tasks-notification-preferences.page.js'),
        },
        {
            id: 'tasks.web.detail',
            moduleId: 'tasks',
            path: '/tasks/:taskId',
            requiredPermission: 'tasks.tasks.read-own',
            navigation: null,
            load: () => import('./tasks-detail.page.js'),
        },
    ],
};
export default tasksWebModuleContribution;
//# sourceMappingURL=tasks-web.module-contribution.js.map